<template>
	<div class="">
		<div class="back-arrow pl-6 pt-2">
			<router-link to="/model2d">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to Model2d </span>
			</router-link>
		</div>
		<base-page-heading
			title="2D Model Edit"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updateModel2dProperties"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>
		<loading-overlay
			:active="isLoading"
			:can-cancel="true"
		/>

		<div class="row content">
			<EditModel2dTable ref="editmodel2d" />
		</div>
	</div>
</template>

<style scoped>
.back-arrow{
	background-color: #f6f7f8;
}
</style>
